import { useRef } from "react"
import { BubbleTail } from "@/components/ui/bubble-tail"
import { EncryptedText } from "@/components/ui/encrypted-text"
import { MutuPrompt } from "@/components/ui/mutu-prompt"
import { SectionTitle } from "@/components/ui/section-title"
import { TransmissionPanel } from "@/components/ui/transmission-panel"
import { usePinnedReveal } from "@/hooks/use-pinned-reveal"

export function OutroSection() {
  const sectionRef = useRef<HTMLElement>(null)
  const bubbleRef = useRef<HTMLDivElement>(null)
  const bodyRef = useRef<HTMLDivElement>(null)
  const tailRef = useRef<HTMLSpanElement>(null)

  usePinnedReveal({ sectionRef, bubbleRef, bodyRef, tailRef })

  return (
    <section
      ref={sectionRef}
      id="outro"
      className="relative z-10 flex w-full flex-col items-start px-5 py-16 sm:px-10 sm:py-28 md:z-auto md:min-h-svh lg:py-32"
    >
      <div className="relative z-30 self-center">
        <SectionTitle prefix="Next" accent="Transmission" />
      </div>

      <div className="relative z-30 mt-12 w-full max-w-2xl sm:mt-16 sm:ml-24 lg:ml-48">
        <div ref={bubbleRef} className="relative">
          <TransmissionPanel className="p-7 sm:p-8">
            <div ref={bodyRef}>
              <MutuPrompt verb="broadcast" subject="Eklo II" />
              <p className="mt-5 font-mono text-foreground text-sm leading-relaxed sm:text-base sm:leading-[1.7]">
                <EncryptedText
                  text="EKLO-II is coming. Oct 2027."
                  encryptedClassName="text-label-dim"
                  revealedClassName="text-foreground"
                  revealDelayMs={55}
                  flipDelayMs={45}
                />
              </p>
              <p className="mt-3 font-mono text-foreground text-sm leading-relaxed sm:text-base sm:leading-[1.75]">
                <EncryptedText
                  text="I am contractually obligated to be excited. Are you?"
                  encryptedClassName="text-label-dim"
                  revealedClassName="text-foreground"
                  revealDelayMs={45}
                  flipDelayMs={45}
                />
              </p>
              <p className="mt-5 font-mono text-[10px] text-label uppercase tracking-[0.4em]">
                <span className="text-label-dim">{"//"}</span> see you in 2090
              </p>
            </div>
          </TransmissionPanel>
          <BubbleTail ref={tailRef} side="right" />
        </div>
      </div>
    </section>
  )
}
